import React, { useRef, useState, useEffect } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { useReactToPrint } from "react-to-print";

import styles from "../../../styles.module.css"; // Ensure this path is correct
import {
  Breadcrumb,
  StyledTableCell,
  StyledTableRow,
} from "../../reusableComponent/Reusables";
import HeaderSection from "../../reusableComponent/HeaderSection";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import cylinder_under_maintaince from "../../../services/report/cylinder_under_maintaince";
import plantMasterService from "../../../services/masters/plantMaster.Service";

const CylinderUnderMaintenance = () => {
  const [searchKey, setSearchKey] = useState("");
    const [total_count,setTotalCount]=useState(null)
    useEffect(() => {
      setTotalCount(rows[0]?.totalCount);
    }, [rows]);
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: 10,
  });
  const [plants, setPlants] = useState([]);
  const [selectedPlant, setSelectedPlant] = useState("");
  const [successMessage, setSuccessMessage] = useState(null);
  const [rows, setRows] = useState([]);

  // // Fetch plants on mount
  // useEffect(() => {
  //   const fetchPlants = async () => {
  //     try {
  //       const plantResponse = await plantMasterService.getPlantList(); 
  //     } catch (error) {
  //      setSuccessMessage("Error fetching plants");
  //     }
  //   };

  //   fetchPlants();
  // }, []);

  // Fetch Data with filters (including plant)
  const fetchData = async () => {
    try {
      const params = {
        page: controller.page,
        size: controller.rowsPerPage,
        searchKey,
        plantId: selectedPlant, // Add plantId as filter param
      };
      const response = await cylinder_under_maintaince.getcylindeundermaintaincerepotlist(params);
      setRows(response || []);
    } catch (error) {
      setSuccessMessage("Error fetching data");
    }
  };

  // Fetch data on dependency change
  useEffect(() => {
    fetchData();
  }, [controller.page, controller.rowsPerPage, searchKey, selectedPlant]);

  // Handlers
  const handleChangePage = (event, newPage) => {
    setController((prev) => ({ ...prev, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setController({
      page: 0,
      rowsPerPage: parseInt(event.target.value, 10),
    });
  };

  const handleSearch = (e) => {
    setSearchKey(e.target.value);
    setController((prev) => ({ ...prev, page: 0 }));
  };

  const handlePlantChange = (event) => {
    setSelectedPlant(event.target.value);
    setController((prev) => ({ ...prev, page: 0 }));
  };

  const start = controller.page * controller.rowsPerPage;
  const end = start + controller.rowsPerPage;
  const paginatedRows = rows.slice(start, end);
  const paginationInfo = `${start + 1}-${Math.min(end, rows.length)} of ${rows.length}`;

  // Print
  const printRef = useRef();
  const printFunction = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "Cylinders Under Maintenance",
    removeAfterPrint: true,
  });

  const handlePrint = () => {
    printFunction();
  };

  return (
    <Box className={styles.cts_page} sx={{ padding: "0px !important", margin: "0px !important" }}>
      <Box className={styles.body}>
        <Breadcrumb routeSegments={[{ name: "Cylinders Under Maintenance" }]} />

        <HeaderSection
          title="CYLINDERS UNDER MAINTENANCE
"
          searchKey={searchKey}
          handleSearch={handleSearch}
          sortedRows={rows}
          fields={[]}
          labels={[]}
          filename="Cylinders Under Maintenance"
          paginationInfo={paginationInfo}
          controller={controller}
          handleChangePage={handleChangePage}
          showAddButton={false}
          PrintIcon_print={{ onClick: handlePrint }}
        />

        {/* Plant Filter Dropdown */}
 {/* <Box sx={{ display: "flex", justifyContent: "flex-end", marginBottom: 2 }}>
  <FormControl size="small" sx={{ minWidth: 150 }}>
    <InputLabel id="plant-filter-label">Filter by Plant</InputLabel>
    <Select
      labelId="plant-filter-label"
      value={selectedPlant}
      label="Filter by Plant"
      onChange={handlePlantChange}
      size="small"
    >
      <MenuItem value="">
        <em>All Plants</em>
      </MenuItem>
      {plants.map((plant) => (
        <MenuItem key={plant.id} value={plant.id}>
          {plant.name}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Box> */}


        <Paper sx={{ width: "100%" }}>
          <TableContainer component={Paper} className={styles.list_tbl_container} ref={printRef}>
            <Table size="small" stickyHeader>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell align="left">Cylinder Code</StyledTableCell>
                  <StyledTableCell align="left">Product Name</StyledTableCell>
                  <StyledTableCell align="left">Product Code</StyledTableCell>
                  {/* <StyledTableCell align="right">Count</StyledTableCell> */}
                </StyledTableRow>
              </TableHead>
              <TableBody sx={{ backgroundColor: "#fff" }}>
                {paginatedRows.map((row, index) => (
                  <StyledTableRow key={index}>
                    <StyledTableCell align="left">{row.cylinder_code}</StyledTableCell>
                    <StyledTableCell align="left">{row.product_name}</StyledTableCell>
                    <StyledTableCell align="left">{row.product_code}</StyledTableCell>
                    {/* <StyledTableCell align="right">{row.count}</StyledTableCell> */}
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            component="div"
            count={rows.length}
            page={controller.page}
            onPageChange={handleChangePage}
            rowsPerPage={controller.rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>

        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => {
            if (reason !== "clickaway") {
              setSuccessMessage("");
            }
          }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </Box>
  );
};

export default CylinderUnderMaintenance;
